import { IRoleEnum } from "@interfaces";
import { createRoute } from "@routes/utils";

import { subscriptionRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const permission = [IRoleEnum.SUPER_ADMIN];

const subscriptionRouteMetadata: IRouteMetadataObj<
  typeof subscriptionRoutesObj
> = {
  list: {
    title: "financialManagement.index.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/subscription/table/page"),
    mode: "index",
    type: "main",
    icon: "ReceiptLine",
    breadcrumbs: [],
    permission,
  },
  settledPaymentView: {
    title: "financialManagement.subscriptions.view.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/subscription/view/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  cancelledPaymentView: {
    title: "financialManagement.subscriptions.view.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/subscription/view/page"),
    mode: "view",
    type: "inner",
    icon: "EyeLine",
    breadcrumbs: [],
    permission,
  },
  pay: {
    title: "financialManagement.subscriptions.pay.title",
    description: "empty",
    lazy: () => import("@/pages/financialManagement/subscription/view/page"),
    mode: "view",
    type: "inner",
    icon: "Eye2Line",
    breadcrumbs: [],
    permission,
  },
};

export const subscriptionRoutes = createRoute<typeof subscriptionRoutesObj>(
  subscriptionRoutesObj,
  subscriptionRouteMetadata,
);
